import { useQuery } from '@tanstack/react-query';
import { apiClient as api } from '@plerionhq/design-system';

export interface AuthenticatorMFA {
  type: 'authenticator';
  enforce: boolean;
}
export type MFAPolicy = AuthenticatorMFA;

export interface Admin {
  createdAt: string;
  id: string;
  sk: string;
  type: string;
  updatedAt: string;
  userId: string;
}

export interface PasswordPolicy {
  minLength: number;
  lowercase?: boolean;
  uppercase?: boolean;
  numeric?: boolean;
  symbol?: boolean;
  restrictUserNamePart?: boolean;
  restrictFirstName?: boolean;
  restrictLastName?: boolean;
  restrictCommonPassword?: boolean;
  enforceHistory?: boolean;
  restrictLastPasswordCount?: number;
  minPasswordAge?: number;
  enforceMinPasswordAge?: boolean;
}

export interface SamlSSO {
  type: 'saml';
  certificate: string;
  idpId: string;
  url: string;
  updatedAt: string;
}
export type SSO = SamlSSO;

export interface OrgProfile {
  type: 'direct' | 'partner';
  entitlement?: string[];
  name: string;
  status: 'active' | 'delete_in_progress';
  deleteScheduledAt?: string;
}
export interface Organization {
  id: string;
  profile: OrgProfile;
  mfaPolicies?: MFAPolicy[];
  passwordPolicy: PasswordPolicy;
  sso?: SSO[];
}

export function useOrganizationInfo() {
  return useQuery({
    queryKey: ['organizationInfo'],
    queryFn: () =>
      api.get<Organization>(`/api/base/organization`).then((res) => {
        return res.data;
      }),
  });
}
